import { Injectable } from '@angular/core';
import { get1, put } from 'src/utils/api';

export interface ReferralQueueParams {
  pageNumber?: number;
  pageSize?: number;
  search?: string;
  referralStatus?: string;
  referralPriority?: string;
  assignedTo?: string;
  rqStatus?: string;
  bucket?: string;
  isMissingDocs?: boolean;
  fromDate?: string;
  toDate?: string;
  facilityName?: string;
  facilityNames?: string;
  costCenter?: string;
  myQueue?: boolean;
  senderName?: string;
  senderFax?: string;
  documentSource?: string;
  referralTargetSystem?: string;
  orderNumber?: string;
  isReferral?: boolean;
  processStatus?: string;
  sortColumn?: string;
  sortDirection?: string;
}

export interface ReferralSummary {
  totalReferrals: number;
  pending: number;
  inProgress: number;
  completed: number;
  highPriority: number;
  missingDocs: number;
}

@Injectable({ providedIn: 'root' })
export class IncomingReferralService {
  private baseUrl = 'api/referralqueue';

  // The queue screens re-fire this on every filter/page change, auto-refresh tick and SignalR
  // push, so they pass an AbortSignal to drop the superseded call — otherwise whichever response
  // lands last wins and the grid can end up rendering rows for filters the user has moved past.
  getQueue(params: ReferralQueueParams, signal?: AbortSignal) {
    return get1(this.baseUrl, { params, signal });
  }

  getLookups() {
    return get1(`${this.baseUrl}/lookups`);
  }

  getProcessStatuses() {
    return get1(`${this.baseUrl}/unique-process-status`);
  }

  getSummary(params?: { myQueue?: boolean; assignedTo?: string; referralStatus?: string; bucket?: string }, signal?: AbortSignal) {
    return get1(`${this.baseUrl}/summary`, { params, signal });
  }

  updateStatus(packetId: string, referralStatus: string) {
    return put(`${this.baseUrl}/${packetId}/referral-status`, { referralStatus });
  }

  updatePriority(packetId: string, referralPriority: string) {
    return put(`${this.baseUrl}/${packetId}/referral-priority`, { referralPriority });
  }
}
